import React from "react";

import TextField from "@material-ui/core/TextField";
import { FormControl, Card, Button, Grid, Select } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import CalendarToday from '@material-ui/icons/CalendarToday';
import CircularProgress from '@material-ui/core/CircularProgress';
import unrecognizedDocsStyles from "./ManageUnrecognizedDoc.module.css";
import commonStyles from '../../common/common.module.css';
import attachmentTypes from '../../../configs/attachmentTypes';
import UnrecognizedDocs from "../../../models/AutoDocRecognitionResponse";
import { Moment } from 'moment';

interface ManageUnrecognizedDocComponentProps {
  unrecognizedDocData: UnrecognizedDocs;
  handleDelete: Function;
  selUnrecognizedDoc: string;
  awb_num: string;
  attachmentType: string;
  changeAttachmentType: (event: any) => void;
  awb_numError: string;
  handleChange: (type: string, event: any) => void;
  handleLinkDocToAwb: () => void;
  handleClick: () => void;
  onChange: (event: any) => void;
  attachToType: string;
  attachToTypeError: string;
  order_num: string;
  orderNumError: string;
  rfs_no: string;
  rfsNoError: string;
  rfsDate: Moment;
  attachmentOtherName: string;
  progressBar: boolean;
};

const ManageUnrecognizedDocComponent = (props: ManageUnrecognizedDocComponentProps) => {

  const attachToTypesArr: Array<{id: string; label: string}> = [
    { id: 'awb_no', label: 'Airwaybill #' },
    { id: 'order_no', label: 'Order #' },
    { id: 'rfs_no', label: 'RFS #' }
  ];
  const attachTypeOptions: Array<JSX.Element> = attachToTypesArr.map((item:{id: string; label: string}) => (
    <option key={ item.id } value={ item.id }>{ item.label }</option>
  ));
  const attachmentTypesArr: Array<{id: string; label: string}> = attachmentTypes.attachmentTypes['export'];
  const attachmentTypeOptions: Array<JSX.Element> = attachmentTypesArr.map((item:{id: string; label: string}) => (
    <option key={ item.id } value={ item.id }>{ item.label }</option>
  ));
  const showVal = true;

  return (
    <div className={ unrecognizedDocsStyles.methodCol }>
      <p className={ unrecognizedDocsStyles.unrecognizedDocTitle }>Manage Document</p>

      <div>
        <Card classes={{ root: unrecognizedDocsStyles.paper }}>
          <form onKeyDown={event => {
            if (event.key === 'Enter') {
              event.preventDefault();
              props.handleLinkDocToAwb();
            }
          }}>
            <div className={ unrecognizedDocsStyles.manageDocOuter }>
              <Grid container direction="column" className={ unrecognizedDocsStyles.manageDocgridContainer }>
                <Grid item sm={12} xs={12} className={ unrecognizedDocsStyles.manageDocgridItems }>
                  <Button
                    variant="contained"
                    disabled={ !props.selUnrecognizedDoc ? true : false }
                    onClick={ () => { props.handleDelete(props.unrecognizedDocData.attachment_key) } }
                    color="primary"
                    className={ unrecognizedDocsStyles.w100 }
                  >
                  Delete Document
                  </Button>
                </Grid>
                <Grid item sm={12} xs={12} className={ unrecognizedDocsStyles.manageDocgridItems }>
                  <h3 className={ unrecognizedDocsStyles.textCenter }>OR</h3>
                </Grid>
                <Grid item sm={12} xs={12} className={ unrecognizedDocsStyles.manageDocgridItems }>
                  <FormControl className={ [unrecognizedDocsStyles.dtlsText, unrecognizedDocsStyles.labelOuter, unrecognizedDocsStyles.w_100].join(" ") }>
                    <label className={ commonStyles.label }>Attach Document to</label>
                    <Select
                      native
                      disabled={ !props.selUnrecognizedDoc ? true : false }
                      value={ props.attachToType ? props.attachToType : '' }
                      onChange={ props.onChange }
                      error={ props.attachToTypeError !== '' }
                      onClick={ props.handleClick }
                      className={ `${ unrecognizedDocsStyles.select } ${unrecognizedDocsStyles.selectField}` }
                      variant="outlined"
                    >
                      <option value={-1} />
                      { attachTypeOptions }
                    </Select>
                    { props.attachToTypeError !== '' &&
                        <span className={ unrecognizedDocsStyles.errorText }>{ props.attachToTypeError }</span>
                    }
                  </FormControl>
                </Grid>

                { props.attachToType == 'awb_no' &&
                  <Grid item sm={12} xs={12} className={ unrecognizedDocsStyles.manageDocgridItems }>
                    <FormControl className={ [unrecognizedDocsStyles.dtlsText, unrecognizedDocsStyles.labelOuter, unrecognizedDocsStyles.w_100].join(" ") }>
                      <label className={ commonStyles.label }>Enter Airwaybill Number</label>
                      <TextField
                        required
                        autoFocus
                        value={ props.awb_num }
                        id="awb_num"
                        disabled={ !props.selUnrecognizedDoc ? true : false }
                        onChange={ (event) =>  props.handleChange('awb_no', event) }
                        onClick={ props.handleClick }
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          classes: { root: unrecognizedDocsStyles.inputtextField }
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={ props.awb_numError !== '' }
                      />
                      { props.awb_numError !== '' &&
                        <span className={ unrecognizedDocsStyles.errorText }>{ props.awb_numError }</span>
                      }
                    </FormControl>
                  </Grid>
                }

                { props.attachToType == 'order_no' &&
                  <Grid item sm={12} xs={12} className={ unrecognizedDocsStyles.manageDocgridItems }>
                    <FormControl className={ [unrecognizedDocsStyles.dtlsText, unrecognizedDocsStyles.labelOuter, unrecognizedDocsStyles.w_100].join(" ") }>
                      <label className={ commonStyles.label }>Enter Order Number</label>
                      <TextField
                        required
                        autoFocus
                        value={ props.order_num }
                        id="order_num"
                        disabled={ !props.selUnrecognizedDoc ? true : false }
                        onChange={ (event) =>  props.handleChange('order_no', event) }
                        onClick={ props.handleClick }
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          classes: { root: unrecognizedDocsStyles.inputtextField }
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={ props.orderNumError !== '' }
                      />
                      { props.orderNumError !== '' &&
                        <span className={ unrecognizedDocsStyles.errorText }>{ props.orderNumError }</span>
                      }
                    </FormControl>
                  </Grid>
                }

                { props.attachToType == 'rfs_no' &&
                  <Grid item sm={12} xs={12}>
                    <Grid container>
                      <Grid item sm={6} xs={6} className={ unrecognizedDocsStyles.manageDocgridItems }>
                        <FormControl className={ [unrecognizedDocsStyles.dtlsText, unrecognizedDocsStyles.labelOuter, unrecognizedDocsStyles.w_100].join(" ") }>
                          <label className={ commonStyles.label }>Enter RFS #</label>
                          <TextField
                            required
                            autoFocus
                            value={ props.rfs_no }
                            id="rfs_no"
                            disabled={ !props.selUnrecognizedDoc ? true : false }
                            onChange={ (event) =>  props.handleChange('rfs_no', event) }
                            onClick={ props.handleClick }
                            InputProps={{
                              classes: { root: `${unrecognizedDocsStyles.inputtextField}
                              ${unrecognizedDocsStyles.unrecogField} ${unrecognizedDocsStyles.unrecogFieldPaddingx}` }
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            error={ props.rfsNoError !== '' }
                            className={ unrecognizedDocsStyles.unrecogFieldOuter }
                            variant="outlined"
                          />
                          { props.rfsNoError !== '' &&
                            <span className={ unrecognizedDocsStyles.errorText }>{ props.rfsNoError }</span>
                          }
                        </FormControl>
                      </Grid>

                      <Grid item sm={6} xs={6} className={ unrecognizedDocsStyles.manageDocgridItems }>
                        <FormControl className={ [unrecognizedDocsStyles.dtlsText, unrecognizedDocsStyles.labelOuter, unrecognizedDocsStyles.w_100].join(" ") }>
                          <label className={ commonStyles.label }>RFS Date</label>
                          <KeyboardDatePicker
                            label=''
                            value={ props.rfsDate }
                            format={ 'DD-MMM-YYYY' }
                            onChange={ (date) => props.handleChange('rfs_date', date) }
                            InputProps={{
                              classes: { root: `${unrecognizedDocsStyles.inputtextField} ${unrecognizedDocsStyles.unrecogField}` }
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            variant="inline"
                            inputVariant="outlined"
                            className={ unrecognizedDocsStyles.unrecogFieldOuter }
                            autoOk
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                }
                { props.attachToType && <Grid item sm={12} xs={12} className={ unrecognizedDocsStyles.manageDocgridItems }>
                  <label className={ commonStyles.label }>Select Document Type</label>
                  <FormControl className={ [unrecognizedDocsStyles.dtlsText, unrecognizedDocsStyles.labelOuter, unrecognizedDocsStyles.w_100].join(" ") }>
                    <Select native
                      onChange={ props.changeAttachmentType }
                      value={ props.attachmentType }
                    >
                    { attachmentTypeOptions }
                    </Select>
                  </FormControl>
                </Grid> }
                { props.attachmentType == 'awb_other' &&
                  <Grid item sm={12} xs={12} className={ unrecognizedDocsStyles.manageDocgridItems }>
                    <FormControl className={ [unrecognizedDocsStyles.dtlsText, unrecognizedDocsStyles.labelOuter, unrecognizedDocsStyles.w_100].join(" ") }>
                      <label className={ commonStyles.label }>Enter Airwaybill Number</label>
                      <TextField
                        required
                        autoFocus
                        value={ props.attachmentOtherName }
                        id="awb_other"
                        disabled={ !props.selUnrecognizedDoc ? true : false }
                        onChange={ (event) =>  props.handleChange('attachment_other', event) }
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          classes: { root: unrecognizedDocsStyles.inputtextField }
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={ props.awb_numError !== '' }
                      />
                      { props.awb_numError !== '' &&
                        <span className={ unrecognizedDocsStyles.errorText }>{ props.awb_numError }</span>
                      }
                    </FormControl>
                  </Grid>
                }
           
                <Grid item sm={12} xs={12} className={ unrecognizedDocsStyles.manageDocgridItems }>
                  <Button
                    variant="contained"
                    disabled={ !props.selUnrecognizedDoc || props.progressBar ? true : false }
                    onClick={ props.handleLinkDocToAwb }
                    color="primary"
                    className={`${unrecognizedDocsStyles.w100} ${unrecognizedDocsStyles.buttonHeight }`}
                  >
                    {props.progressBar ? (
                      <CircularProgress color="primary" className={unrecognizedDocsStyles.paddingClass} />
                    ) : (
                      "Save"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default ManageUnrecognizedDocComponent;
